export class NotFoundError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}

export class RentalApplicationNotFoundError extends NotFoundError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, RentalApplicationNotFoundError.prototype);
  }
}

export class FailedToFetchError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, FailedToFetchError.prototype);
  }
}

export class HttpError extends Error {
  private httpStatusCode: number;
  private errorType?: string;

  constructor(httpStatusCode: number, underlyingErrorMessage?: string, errorType?: string) {
    super(underlyingErrorMessage);
    Object.setPrototypeOf(this, HttpError.prototype);
    this.httpStatusCode = httpStatusCode;
    this.errorType = errorType;
  }

  public getStatusCode(): number {
    return this.httpStatusCode;
  }

  public getErrorType(): string | undefined {
    return this.errorType;
  }
}

export class PayloadTooLargeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, PayloadTooLargeError.prototype);
  }
}

export class FailedToConnectError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, FailedToConnectError.prototype);
  }
}

export class UnauthorizedError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, UnauthorizedError.prototype);
  }
}

export class CannotPerformScreeningError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, CannotPerformScreeningError.prototype);
  }
}
